import { useCurrentUser } from "@twinkltech/curriculum-architect-domain-hooks";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { userPermissions } from "@/utils/userPermissions/userPermissions";

import { paths } from "@/paths";

const ALLOWED_INDIVIDUAL_CORE_PATHS = [
  paths.EXPLORE_SCHEME_LIST_CONTENTS_PATH,
  paths.EXPLORE_SUBJECT_CONTENTS_SCHEME_PATH,
  paths.CURRICULUM_GOAL_PATH,
] as const;

export const RouteGuard = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: userData } = useCurrentUser();

  useEffect(() => {
    const permissions = userPermissions(userData);
    const isIndividualCoreUser = !permissions.canViewCurricula;

    const currentPath = location.pathname;

    if (isIndividualCoreUser) {
      const isAllowedPath = ALLOWED_INDIVIDUAL_CORE_PATHS.some((path) =>
        currentPath.startsWith(path)
      );

      if (!isAllowedPath) {
        navigate(paths.EXPLORE_SCHEME_LIST_CONTENTS_PATH);
      }
    }
  }, [location.pathname, navigate, userData]);

  return <>{children}</>;
};
